import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_vq4dxxsy59: FaireBrandEntity = {
  token: "b_vq4dxxsy59",
  type: "brand",
  name: "Prime Opticals",
  avatarUrl:
    "https://cdn.faire.com/fastly/d950c48528b0fbadf38ab3639f8affd50bd58a8b077b1edab7960f9e16c62494.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/cf4e3afc373eaa01c7f3817791b7c8700602e9eebdd3be8880c2a1fcfa5dbb71.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/d950c48528b0fbadf38ab3639f8affd50bd58a8b077b1edab7960f9e16c62494.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/cf4e3afc373eaa01c7f3817791b7c8700602e9eebdd3be8880c2a1fcfa5dbb71.jpeg",
  location: "Maspeth, NY, USA",
  minimumOrderDollars: 150,
  rating: 4.6,
  reviewCount: 182,
  isInsider: true,
  description:
    "Welcome to Prime Opticals, our world of eyewear, where excellence in product design and quality meets unparalleled customer service. As a leading manufacturer and, now, importer of sunglasses and reading glasses, we are passionate about crafting eyewear that not only protects your eyes but also complements your unique style.\n\nOur commitment to quality ensures that every pair of glasses is made with premium materials, designed to last and provide comfort. We believe that eyewear should be more than just functional; it should be a reflection of your personality. That's why our team is dedicated to constantly developing new and trendy designs, keeping you at the forefront of fashion while ensuring durability and comfort.\n\nAt the heart of our mission is a focus on great customer service. We pride ourselves on building lasting relationships with our clients, ensuring that your experience with us is as enjoyable as it is seamless. Our knowledgeable staff is always here to assist you, whether you have questions about our products or need guidance in selecting the perfect pair.\n\nJoin us on this exciting journey as we redefine eyewear, merging style with functionality. Discover the difference that our commitment to excellence makes, and let us help you find the perfect pair of glasses to express your individuality!",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:59:19.828Z",
    importedBy: "entity-db-cli",
  },
};
